export default function Navigation({ handlePrevious, handleNext }) {
  return (
    <div className="nav">
      <div className="nav-btn prev" onClick={handlePrevious}></div>
      <div className="nav-btn next" onClick={handleNext}></div>
    </div>
  );
}
